<template>
    <div class="myCourse bjStyle">
        <div class="box">
            <el-tabs v-model="activeName">
                <el-tab-pane label="我的课程" name="my-course">
                    <CourseList />
                </el-tab-pane>
                <el-tab-pane label="教材版本" name="textbook-version">
                    <TextbookVersions />
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
import CourseList from '../personalDetail/courseList.vue';
import TextbookVersions from "../textbookVersions";
export default {
    name: 'myCourse',
    components: { CourseList, TextbookVersions },
    data(){
        return {
            activeName: "my-course",
        };
    },
}
</script>

<style lang="scss" scoped>
@include bjStyle;
</style>